<template>
  <div>
    <v-tabs
      v-model="viewPage"
      color="white"
      :slider-color="$vuetify.theme.primary"
      style="font-size: 18px"
    >
      <v-tab
        v-for="(item, index) in menuItem"
        :key="`menu-item-${index}`"
        style="text-transform: capitalize"
        ripple
        :href="`#${item.view}`"
        @click="updateSlug(item.view)"
        >{{ item.text }}</v-tab
      >
    </v-tabs>
    <div id="view-content-techhunt" class="mt-4">
      <Campaign v-if="view == 'campaign'" />
      <Agency v-if="view == 'agency'" />
      <Category v-else-if="view == 'category'" />
      <Type v-else-if="view == 'type'" />
      <Tag v-else-if="view== 'tag'"/>
      <Unit v-else-if="view== 'unit'"/>
    </div>
  </div>
</template>

<script>
import Campaign from './Campaign'
import Category from './Category'

import Type from './Type'
import Agency from './Agency.vue'
import Tag from './Tag.vue'
import Unit from './Unit.vue'
export default {
  components: {
    Campaign,
    Category,
    Type,
    Agency,
    Tag,
    Unit
  },
  data() {
    return {
      menuData: [
        {
          text: this.$t('campaign'),
          view: 'campaign',
        },
        {
          text: this.$t('หน่วยร่วม'),
          view: 'agency',
        },
        {
          text: this.$t('Techhunt Type'),
          view: 'type',
        },
        {
          text: this.$t('Category'),
          view: 'category',
        },
        {
          text: this.$t('Tags'),
          view: 'tag',
        },
        {
          text: this.$t('หน่วยราคา'),
          view: 'unit',
        },
      ],
      viewPage: 'campaign',
    }
  },
  mounted() {},
  computed: {
    menuItem() {
      // if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
      //   return this.menuData.filter((el) => {
      //     return ['couponreport', 'techproviderandproductreport'].includes(el.view)
      //   })
      // } else {
        return this.menuData
      // }
    },
    view() {
      var defaultview = 'campaign'
      // if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
      //   defaultview = 'couponreport'
      // }
      this.viewPage = this.$route.query.view ? this.$route.query.view : defaultview
      return this.$route.query.view ? this.$route.query.view : defaultview
    },
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.border-bot {
  border-bottom: 2px solid #152d53;
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/main.vue